module.exports = __webpack_public_path__ + "img/manual_arrow.2fb16136.png";